module.exports = __webpack_public_path__ + "img/form.78d37922.svg";